import React from "react";
import { Modal } from "react-bootstrap";
import { MecordColors } from "Constants/Color";
import ProductForm from "../../../Master/product/Form/ProductForm";
import { useDispatch } from "react-redux";
import { fetchCategoryByDropDown } from "slices/Masters/category/thunk";

interface AddProductModalProps {
  show: boolean;
  onHide: () => void;
  onSave?: (productData: any) => void;
}

const AddProductModal: React.FC<AddProductModalProps> = ({
  show,
  onHide,
  onSave,
}) => {
  const dispatch = useDispatch<any>();

  const handleSuccess = async () => {
    // Refresh category dropdown (which will refresh products)
    await dispatch(fetchCategoryByDropDown());
    // Call onSave if provided
    if (onSave) {
      onSave({});
    }
    // Close modal
    onHide();
  };

  return (
    <>
      <style>
        {`
          /* Make React-Bootstrap white close button fully bright */
          .bright-white-close .btn-close {
            filter: invert(1) brightness(2);
            opacity: 1;
          }
          .bright-white-close .btn-close:hover {
            filter: invert(1) brightness(2.5);
          }
        `}
      </style>
      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        size="xl"
        centered
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{
            backgroundColor: MecordColors?.ThemeBGColor,
            paddingBottom: "20px",
          }}
          className="bright-white-close"
        >
          <Modal.Title style={{ color: "#fff" }}>Add Product</Modal.Title>
        </Modal.Header>
      <Modal.Body
        style={{
          maxHeight: "80vh",
          overflowY: "auto",
          padding: "20px",
        }}
      >
        <ProductForm isModal={true} onSuccess={handleSuccess} />
      </Modal.Body>
    </Modal>
    </>
  );
};

export default AddProductModal;
